import React, {Component} from "react";
import {Growl} from 'primereact/growl';
import ActiveMarketLoansView from "./ActiveMarketLoansView";
import {ReportsService} from "../../../service/reports/ReportsService";
import ConfirmationMessage from "../../../components/confirmationMessage";

export default class ActiveGuaranteesDetailContainer extends Component {
    constructor(props) {
        super(props);

        this.reportsService = new ReportsService();
        this.getDataReport = this.getDataReport.bind(this);
        this.exportDocument = this.exportDocument.bind(this);
        this.confirmationRef = null;
        this.today = new Date();
        this.setConfirmationRef = element => {
            this.confirmationRef = element
        };

        this.state = {
            isLoading: false,
            filters: {
                startDate: this.today,
                finalDate: this.today,
                today: this.today,
            },
            dataReport: [],
            exportOptions: [
                {
                    label: "Excel", action: () => {
                        this.openConfirmationMessage("Excel")
                    }
                },
                {
                    label: "PDF", action: () => {
                        this.openConfirmationMessage("PDF")
                    }
                },
            ],
            typeDocument: '',
            disabledSearchButton: false,
        };

        this.onChangeFilters = this.onChangeFilters.bind(this);
        this.openConfirmationMessage = this.openConfirmationMessage.bind(this);
        this.clearFilters = this.clearFilters.bind(this);
        this.loading = this.loading.bind(this);
    }

    componentDidMount() {
        let message = this.props.location.message ? this.props.location.message : null;
        if (message !== null && message.severity) {
            this.growl.show({
                severity: message.severity ? message.severity : '',
                summary: message.summary ? message.summary : '',
                detail: message.detail ? message.detail : '', message
            });
        }
    }

    loading(option) {
        if (this.state !== undefined) {
            this.setState({
                isLoading: option ? option : false,
            });
        }
    }

    clearFilters() {
        this.setState({
            filters: {
                startDate: this.today,
                finalDate: this.today,
                today: this.today,
            },
        });
    }

    onChangeFilters(event) {
        let filtersAux = this.state.filters;
        if (event.target.name === "startDate") {
            filtersAux[event.target.name] = event.target.value;
            filtersAux['finalDate'] = event.target.value;
        } else {
            filtersAux[event.target.name] = event.target.value ? event.target.value : "";
        }
        this.setState({
            filters: filtersAux,
        });
    }


    openConfirmationMessage(docType) {
        if (this.confirmationRef) {
            this.setState({
                typeDocument: docType
            });
            this.confirmationRef.openConfirmationMessage();
        }
    }

    getDataReport() {
        this.loading(true);
        this.setState({
            disabledSearchButton: true,
        });
        this.reportsService.getMarketActiveReport(this.state.filters)
            .then(resp => {
                if (resp.error !== '') {
                    this.growl.show({
                        severity: 'info', summary: 'Atención.',
                        detail: resp.error
                    });
                }
                this.setState({
                    dataReport: resp.payload,
                    disabledSearchButton: false,
                });
                this.loading(false);
            });
    }

    exportDocument() {
        this.loading(true);
        if (this.state.dataReport.length === 0) {
            this.growl.show({
                severity: 'info', summary: 'Atención.',
                detail: 'No existen datos'
            });
            this.loading(false);
        } else {
            let params = {
                bandera: 0,
                tipoReporte: 7,
                fechaInicial: this.state.filters.startDate.getFullYear() + "-" +
                    (this.state.filters.startDate.getMonth() + 1) + "-" +
                    this.state.filters.startDate.getDate(),
                fechaFinal: this.state.filters.finalDate.getFullYear() + "-" +
                    (this.state.filters.finalDate.getMonth() + 1) + "-" +
                    this.state.filters.finalDate.getDate(),
            };
            switch (this.state.typeDocument) {
                case "Excel":
                    this.reportsService.getActiveMarketReportXLS(params)
                        .then(res => {
                            this.getDataReport();
                            this.loading(false);
                        });
                    break;
                case "PDF":
                    this.reportsService.getActiveMarketReportPDF(params)
                        .then(res => {
                            this.getDataReport();
                            this.loading(false);
                        });
                    break;
                default:
                    break;
            }
        }
    }

    render() {
        let confMsg = <ConfirmationMessage ref={this.setConfirmationRef}
                                           invisible={true}
                                           legend="¿Usted está seguro de continuar descargando la información solicitada?"
                                           action={this.exportDocument}/>;
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;
        const {dataReport, isLoading, filters, exportOptions, disabledSearchButton} = this.state;

        return <ActiveMarketLoansView
            dataReport={dataReport}
            isLoading={isLoading}
            messagesGrowl={messagesGrowl}
            filters={filters}
            exportOptions={exportOptions}
            confMsg={confMsg}
            disabledSearchButton={disabledSearchButton}
            onChangeFilters={this.onChangeFilters}
            getDataReport={this.getDataReport}
            clearFilters={this.clearFilters}
        />
    }
};